import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateErpLoadListSessionMutationVariables = Types.Exact<{
  input: Types.CreateErpLoadListSessionInput;
}>;


export type CreateErpLoadListSessionMutation = { __typename?: 'Mutation', createErpLoadListSession: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateErpLoadListSessionNameMutationVariables = Types.Exact<{
  input: Types.UpdateErpLoadListSessionNameInput;
}>;


export type UpdateErpLoadListSessionNameMutation = { __typename?: 'Mutation', updateErpLoadListSessionName: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateErpLoadListQuantitiesMutationVariables = Types.Exact<{
  input: Types.UpdateErpLoadListQuantitiesInput;
}>;


export type UpdateErpLoadListQuantitiesMutation = { __typename?: 'Mutation', updateErpLoadListQuantities: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubmitErpLoadListSessionMutationVariables = Types.Exact<{
  input: Types.SubmitErpLoadListSessionInput;
}>;


export type SubmitErpLoadListSessionMutation = { __typename?: 'Mutation', submitErpLoadListSession: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ProcessErpLoadListSessionMutationVariables = Types.Exact<{
  input: Types.ProcessErpLoadListSessionInput;
}>;


export type ProcessErpLoadListSessionMutation = { __typename?: 'Mutation', processErpLoadListSession: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelErpLoadListSessionMutationVariables = Types.Exact<{
  input: Types.CancelErpLoadListSessionInput;
}>;


export type CancelErpLoadListSessionMutation = { __typename?: 'Mutation', cancelErpLoadListSession: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteErpLoadListSessionMutationVariables = Types.Exact<{
  input: Types.DeleteErpLoadListSessionInput;
}>;


export type DeleteErpLoadListSessionMutation = { __typename?: 'Mutation', deleteErpLoadListSession: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateErpLoadListSessionItemAvailabilityMutationVariables = Types.Exact<{
  input: Types.UpdateErpLoadListSessionItemAvailabilityInput;
}>;


export type UpdateErpLoadListSessionItemAvailabilityMutation = { __typename?: 'Mutation', updateErpLoadListSessionItemAvailability: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateErpLoadListSessionRoutesMutationVariables = Types.Exact<{
  input: Types.UpdateErpLoadListSessionRoutesInput;
}>;


export type UpdateErpLoadListSessionRoutesMutation = { __typename?: 'Mutation', updateErpLoadListSessionRoutes: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateErpLoadListSessionShipDateMutationVariables = Types.Exact<{
  input: Types.UpdateErpLoadListSessionShipDateInput;
}>;


export type UpdateErpLoadListSessionShipDateMutation = { __typename?: 'Mutation', updateErpLoadListSessionShipDate: { __typename?: 'ErpLoadListSessionPayload', erpLoadListSession?: { __typename?: 'ErpLoadListSessionStateData', createdAt: Types.TDateISO, createdBy: string, sessionId: string, sessionName: string, stationCode: string, containerCode: string, status: Types.ErpLoadListSessionStatus, tenantId: string, updatedAt?: Types.TDateISO | null, updatedBy?: string | null, items: Array<{ __typename?: 'ErpLoadListItemData', erpItemId: string, stationCode: string, locationName: string, upc: string, productGroup: string, category: string, description: string, availableQuantity: number, inTransitQuantity: number, allocatedQuantity: number, mustGoQuantity: number }>, quantities: Array<{ __typename?: 'ErpLoadListQuantityData', erpItemId: string, routeCode: string, upc: string, quantity: number, containerCode: string, containerUtilization: number, updatedAt: Types.TDateISO, updatedBy: string }>, routes: Array<{ __typename?: 'ErpLoadListRouteData', routeCode: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateErpLoadListSessionDocument = new TypedDocumentString(`
    mutation CreateErpLoadListSession($input: CreateErpLoadListSessionInput!) {
  createErpLoadListSession(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const UpdateErpLoadListSessionNameDocument = new TypedDocumentString(`
    mutation UpdateErpLoadListSessionName($input: UpdateErpLoadListSessionNameInput!) {
  updateErpLoadListSessionName(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const UpdateErpLoadListQuantitiesDocument = new TypedDocumentString(`
    mutation UpdateErpLoadListQuantities($input: UpdateErpLoadListQuantitiesInput!) {
  updateErpLoadListQuantities(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const SubmitErpLoadListSessionDocument = new TypedDocumentString(`
    mutation SubmitErpLoadListSession($input: SubmitErpLoadListSessionInput!) {
  submitErpLoadListSession(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const ProcessErpLoadListSessionDocument = new TypedDocumentString(`
    mutation ProcessErpLoadListSession($input: ProcessErpLoadListSessionInput!) {
  processErpLoadListSession(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const CancelErpLoadListSessionDocument = new TypedDocumentString(`
    mutation CancelErpLoadListSession($input: CancelErpLoadListSessionInput!) {
  cancelErpLoadListSession(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const DeleteErpLoadListSessionDocument = new TypedDocumentString(`
    mutation DeleteErpLoadListSession($input: DeleteErpLoadListSessionInput!) {
  deleteErpLoadListSession(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const UpdateErpLoadListSessionItemAvailabilityDocument = new TypedDocumentString(`
    mutation UpdateErpLoadListSessionItemAvailability($input: UpdateErpLoadListSessionItemAvailabilityInput!) {
  updateErpLoadListSessionItemAvailability(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const UpdateErpLoadListSessionRoutesDocument = new TypedDocumentString(`
    mutation UpdateErpLoadListSessionRoutes($input: UpdateErpLoadListSessionRoutesInput!) {
  updateErpLoadListSessionRoutes(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
export const UpdateErpLoadListSessionShipDateDocument = new TypedDocumentString(`
    mutation UpdateErpLoadListSessionShipDate($input: UpdateErpLoadListSessionShipDateInput!) {
  updateErpLoadListSessionShipDate(input: $input) {
    erpLoadListSession {
      ...LoadListDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadListDetails on ErpLoadListSessionStateData {
  createdAt
  createdBy
  sessionId
  sessionName
  stationCode
  containerCode
  status
  tenantId
  updatedAt
  updatedBy
  items {
    ...LoadListItem
  }
  quantities {
    ...LoadListQuantity
  }
  routes {
    ...LoadListRoute
  }
}
fragment LoadListItem on ErpLoadListItemData {
  erpItemId
  stationCode
  locationName
  upc
  productGroup
  category
  description
  availableQuantity
  inTransitQuantity
  allocatedQuantity
  mustGoQuantity
}
fragment LoadListQuantity on ErpLoadListQuantityData {
  erpItemId
  routeCode
  upc
  quantity
  containerCode
  containerUtilization
  updatedAt
  updatedBy
}
fragment LoadListRoute on ErpLoadListRouteData {
  routeCode
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateErpLoadListSession: build.mutation<CreateErpLoadListSessionMutation, CreateErpLoadListSessionMutationVariables>({
      query: (variables) => ({ document: CreateErpLoadListSessionDocument, variables })
    }),
    UpdateErpLoadListSessionName: build.mutation<UpdateErpLoadListSessionNameMutation, UpdateErpLoadListSessionNameMutationVariables>({
      query: (variables) => ({ document: UpdateErpLoadListSessionNameDocument, variables })
    }),
    UpdateErpLoadListQuantities: build.mutation<UpdateErpLoadListQuantitiesMutation, UpdateErpLoadListQuantitiesMutationVariables>({
      query: (variables) => ({ document: UpdateErpLoadListQuantitiesDocument, variables })
    }),
    SubmitErpLoadListSession: build.mutation<SubmitErpLoadListSessionMutation, SubmitErpLoadListSessionMutationVariables>({
      query: (variables) => ({ document: SubmitErpLoadListSessionDocument, variables })
    }),
    ProcessErpLoadListSession: build.mutation<ProcessErpLoadListSessionMutation, ProcessErpLoadListSessionMutationVariables>({
      query: (variables) => ({ document: ProcessErpLoadListSessionDocument, variables })
    }),
    CancelErpLoadListSession: build.mutation<CancelErpLoadListSessionMutation, CancelErpLoadListSessionMutationVariables>({
      query: (variables) => ({ document: CancelErpLoadListSessionDocument, variables })
    }),
    DeleteErpLoadListSession: build.mutation<DeleteErpLoadListSessionMutation, DeleteErpLoadListSessionMutationVariables>({
      query: (variables) => ({ document: DeleteErpLoadListSessionDocument, variables })
    }),
    UpdateErpLoadListSessionItemAvailability: build.mutation<UpdateErpLoadListSessionItemAvailabilityMutation, UpdateErpLoadListSessionItemAvailabilityMutationVariables>({
      query: (variables) => ({ document: UpdateErpLoadListSessionItemAvailabilityDocument, variables })
    }),
    UpdateErpLoadListSessionRoutes: build.mutation<UpdateErpLoadListSessionRoutesMutation, UpdateErpLoadListSessionRoutesMutationVariables>({
      query: (variables) => ({ document: UpdateErpLoadListSessionRoutesDocument, variables })
    }),
    UpdateErpLoadListSessionShipDate: build.mutation<UpdateErpLoadListSessionShipDateMutation, UpdateErpLoadListSessionShipDateMutationVariables>({
      query: (variables) => ({ document: UpdateErpLoadListSessionShipDateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateErpLoadListSessionMutation, useUpdateErpLoadListSessionNameMutation, useUpdateErpLoadListQuantitiesMutation, useSubmitErpLoadListSessionMutation, useProcessErpLoadListSessionMutation, useCancelErpLoadListSessionMutation, useDeleteErpLoadListSessionMutation, useUpdateErpLoadListSessionItemAvailabilityMutation, useUpdateErpLoadListSessionRoutesMutation, useUpdateErpLoadListSessionShipDateMutation } = injectedRtkApi;
